// extracted by mini-css-extract-plugin
module.exports = {"content":"Account_content__20RV7","section":"Account_section__muo9o"};